<template>
  <div class="miya-contact">
    <div class="contact-box">
      <img class="bg" src="@assets/images/home/contact.svg">
      <div class="bg-shadow">
        <el-popover
          placement="left"
          title=""
          width="150"
          trigger="hover"
          content="">
          <div class="img-box" slot="reference">
            <img class="img" src="@assets/images/home/WeChat.png">
          </div>
          <div class="miya-contact-codeBox">
            <p class="miya-contact-name">{{$t('home.WeChat')}}</p>
            <img class="miya-contact-codeImg" src="@assets/images/login/vx.png">
          </div>        
        </el-popover>
        <el-popover
          placement="left"
          title=""
          width="150"
          trigger="hover"
          content="">
          <div class="img-box" slot="reference">
            <img class="img" src="@assets/images/home/Telegram.png">
          </div>
          <div class="miya-contact-codeBox">
            <p class="miya-contact-name">{{$t('home.Telegram')}}</p>
            <img class="miya-contact-codeImg" src="@assets/images/login/tg.png">
            <p class="miya-contact-miyaip">@MIYA_IP</p>
          </div>        
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
}
</script>
<style scoped lang="stylus">
.miya-contact
  position fixed
  right 2%
  bottom calc(50vh - 73px)
  z-index 50
  border-radius 6px
  box-shadow 3px 6px 16px rgba(0,0,0,0.16)
  .contact-box
    width 80px
    height 146px
    .bg
      position absolute
      top 0
      left 0
      z-index 1
    .bg-shadow
      width 64px
      height 130px
      position absolute
      top 8px
      left 8px
      position relative
      display flex
      flex-direction column
      justify-content center
      z-index 2
      .img-box
        width 100%
        height 65px
        &:hover
          background-color rgba(50,50,50,0.01)
          box-shadow 0 0 16px rgba(50,50,50,0.2) inset
      .img
        position relative
        z-index 2
        width 30px
        height 30px
        margin-left 50%
        margin-top 50%
        transform translate3d(-50%,-50%,0)
.miya-contact-codeBox
  width 124px
  .miya-contact-name
    font-size  $f16
    color $c1
    text-align center
    margin-bottom 8px
  .miya-contact-codeImg
    width 100%
  .miya-contact-miyaip
    font-size  $f16
    color $c2
    text-align center
@media screen and (max-width: 800px)
  .miya-contact
    transform-origin right bottom
    z-index 7
    bottom 1rem !important
    right 1rem !important
    transform scale(0.6)
</style>